import { type JSX } from 'react';

export default function ZeroDashMark(): JSX.Element {
  return (
    <svg
      width="84"
      height="58"
      viewBox="200 230 383 263"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="466" y="443" width="117" height="50" rx="25" fill="#DC67CE" />
      <path d="M333.369 493C308.986 493 286.573 487.391 266.131 476.174C245.934 464.956 229.802 449.35 217.733 429.353C205.911 409.113 200 386.434 200 361.317C200 336.2 205.911 313.643 217.733 293.647C229.802 273.65 245.934 258.044 266.131 246.826C286.573 235.609 308.986 230 333.369 230C357.753 230 380.043 235.609 400.239 246.826C420.681 258.044 436.691 273.65 448.267 293.647C460.089 313.643 466 336.2 466 361.317C466 386.434 460.089 409.113 448.267 429.353C436.444 449.35 420.435 464.956 400.239 476.174C380.043 487.391 357.753 493 333.369 493ZM333.369 435.937C354.058 435.937 370.56 429.109 382.875 415.453C395.436 401.797 401.717 383.752 401.717 361.317C401.717 338.638 395.436 320.593 382.875 307.181C370.56 293.525 354.058 286.697 333.369 286.697C312.434 286.697 295.686 293.403 283.125 306.815C270.81 320.227 264.653 338.395 264.653 361.317C264.653 383.996 270.81 402.163 283.125 415.819C295.686 429.231 312.434 435.937 333.369 435.937Z" fill="#F9D51A" />
    </svg>
  );
}
